import { NotePage } from '../NotePage/NotePage';
import { VitaminInfusionParagraphs } from './Paragraphs';

export const VitaminInfusion = () => (
  <NotePage
    title="Vitamin infusion and nutrient support"
    eyebrow="Wellness note"
    summary="A practical article about hydration, nutrient status, and the questions worth bringing into a private medical consultation."
    paragraphs={VitaminInfusionParagraphs}
    relatedTitle="Vitamin Infusion"
    appointmentServiceValue="Vitamin Infusion"
  />
);
